import styled from 'styled-components'
import {
  LEGACY_BREAKPOINT_QUERIES,
  createResponsiveBreakpointQuery
} from 'styles/breakpoints'

const twoColumnQuery = createResponsiveBreakpointQuery('tabletUp', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.reactGridSmallUp
})

const tabletQuery = createResponsiveBreakpointQuery('tabletUp', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.tabletUp
})

export const Container = styled.div`
  overflow-y: auto;
  align-items: flex-start;
  padding-bottom: 15svh;
`

export const Card = styled.div`
  background: #1e1e1e;
  border-radius: 8px;
  padding: 24px;

  @media ${LEGACY_BREAKPOINT_QUERIES.tabletUp} {
    padding: 32px;
  }
`
export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-bottom: 24px;

  @media ${LEGACY_BREAKPOINT_QUERIES.tabletUp} {
    border-bottom: 1px solid ${({ theme }) => theme.colors.neutralW30};
    padding-bottom: 24px;
  }
`

export const TextRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const Error = styled.p`
  font-size: 12px;
  margin-top: 8px;
  color: ${({ theme }) => theme.colors.error70};
`

export const ProfileColumn = styled.div`
  box-sizing: border-box;
  min-height: 1px;
  min-width: 0;
  padding: 0 16px;
  position: relative;
`

export const ProfileLabelColumn = styled(ProfileColumn)``

export const ProfileValueColumn = styled(ProfileColumn)``

export const ProfileTabletValueColumn = styled(ProfileColumn)``

export const ProfileRow = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  margin-left: -16px;
  margin-right: -16px;
`

export const ProfileRoot = styled(Container)`
  @media ${twoColumnQuery} {
    ${ProfileRow} {
      grid-template-columns: repeat(12, minmax(0, 1fr));
    }

    ${ProfileLabelColumn} {
      grid-column: span 4;
    }

    ${ProfileValueColumn} {
      grid-column: span 8;
    }

    ${ProfileTabletValueColumn} {
      grid-column: 1 / -1;
    }
  }

  @media ${tabletQuery} {
    ${ProfileTabletValueColumn} {
      grid-column: span 8;
    }
  }
`
